export const getOffset = ({ pagination }) => pagination.offset;
